var map = L.map('map').setView([39.5652996, 2.6589835], 15);
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '© OpenStreetMap'
        }).addTo(map);

        // Se crea un icono personalizado
        var photoIcon = L.icon({
            iconUrl: 'build/images/local-icon.png',
            shadowUrl: 'build/images/leaf-shadow.png',
            iconSize: [38, 60], // tamaño del icono
            shadowSize:   [65, 50], // size of the shadow
            iconAnchor: [20, 55], // point of the icon which will correspond to marker's location
            popupAnchor: [0, -15] // posición relativa de la ventana emergente
        });
        

        // Se crea el contenido personalizado de la ventana emergente
        var customPopup = "<img src='build/images/icon.png' alt='Icono de la Clínica Veterinaria Exotely' class='icon-map-exotely' width='10px'/><b><a target='_blank' href='https://exotely.netlify.app/' style='text-decoration:none; color:#263545; font-size:14px'>Exotely Clínica Veterinaria <br/></a><a target='_blank' href='https://goo.gl/maps/QkpqHtQYjsKap4dEA' style='text-decoration:none; font-weight:400; color:#1a73e8'>➦ Obtener instrucciones</a><br/></b></a><small>C/ Joan Alcover 64 – 07006 – Palma de Mallorca – Baleares</small>";

        // Se especifican las opciones de la ventana emergente 
        var customOptions = {
            'maxWidth': '200',
            'className': 'custom'
        }

        // Se crea un objeto marcador, se establece la opción de icono personalizado, se vincula una ventana emergente con contenido y opciones pesonalizadas y se añade al mapa en las coordenadas indicadas
        var marker = L.marker([39.5652996, 2.6589835], { icon: photoIcon }).bindPopup(customPopup, customOptions).addTo(map);